/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Slot_ManyInputs */

const en_slot_many = /** @type {(inputs: Slot_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`slots`)
};

const de_slot_many = /** @type {(inputs: Slot_ManyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Plätze`)
};

/**
* | output |
* | --- |
* | "slots" |
*
* @param {Slot_ManyInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const slot_many = /** @type {((inputs?: Slot_ManyInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Slot_ManyInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_slot_many(inputs)
	return en_slot_many(inputs)
});